import { useEffect, useMemo, useState } from "react";
import { FormikProps } from "formik";
import { OrderInterface } from "../../../interfaces/orderInterface";
import { useShippingCostsQuery } from "../../../features/shippingCosts/queries/useShippingCostQuery";
import { ShippingCost } from "../../../interfaces/shippingCostType";

type UseShippingCosts = {
  formik: FormikProps<OrderInterface>;
  modalIsOpen: boolean;
};

const useShippingCosts = (args: UseShippingCosts) => {
  const { formik, modalIsOpen } = args;
  const { data: shippingCosts = [], isLoading: shippingCostsIsLoading } =
    useShippingCostsQuery();

  const orderId = formik.values._id;

  const selectedShippingCost = useMemo(
    () => formik.values.shippingCost?._id ?? "",
    [formik.values],
  );

  useEffect(() => {
    // Set default shipping cost when modal opens
    if (modalIsOpen && !orderId && !shippingCostsIsLoading) {
      const shippingCostDefaultValue = shippingCosts.find(
        (x) => x.defaultShipping,
      );
      formik.setFieldValue("shippingCost", shippingCostDefaultValue ?? "");
      return;
    }
  }, [modalIsOpen, shippingCosts, shippingCostsIsLoading]);

  const onShippingCostOnChange = (shippingCostId?: ShippingCost) => {
    formik.setFieldValue("shippingCost", shippingCostId);
  };

  return {
    shippingCosts,
    selectedShippingCost,
    onShippingCostOnChange,
  };
};

export default useShippingCosts;
